<template>
  <div class="p-6">
    <div class="flex flex-wrap gap-2 mb-8">
      <div
        v-for="(temp, i) in type_keys"
        class="py-1 px-2.5 rounded-sm border border-gray-200 bg-white text-black cursor-pointer capitalize"
        @click="select_type.type = temp"
        :class="{
          'border-success text-success ': temp == select_type.type,
        }"
      >
        {{ temp }}
      </div>
    </div>
    <div class="grid grid-cols-2 gap-2">
      <div
        class="col-span-1 h-full"
        v-for="(item, i) in templates[select_type.type]"
      >
        <div
          class="p-4 rounded-md bg-gray-200 hover:bg-gray-300 h-full flex flex-col justify-between cursor-pointer items-center gap-2 pt-8"
          @click="ChooseTemplate(item)"
          :class="{
            'bg-sky-200':
              qrcreate.select_template.id == item.id &&
              qrcreate.select_template.type == item.type,
          }"
        >
          <div class="h-[150px] flex-shrink-0 items-center flex justify-center">
            <img
              :src="
                config.public.app_user_url + '/images/templates/' + item.preview
              "
              alt=""
              class="w-full object-contain h-full bg-white"
            />
          </div>
          <p class="font-semibold text-medium">{{ item.name }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useQrCreateStore } from "~~/stores/qrcreate";
import qr_styles from "./canvas/libs";
import { useNotification } from "@kyvg/vue3-notification";
const { notify } = useNotification();
const templates = ref(qr_styles);
const select_type = ref({
  type: "classic",
});
const type_keys = ref(["all", "classic"]);
const qrcreate = useQrCreateStore();
const qrstyle = useQrStyle();
const config = useRuntimeConfig();
const ChooseTemplate = async (item) => {
  if (!qrcreate.config.data || !qrcreate.imageData) {
    notify({
      title: "Please generate the QR code first.",
      text: "We need data before beautifying Qr Code",
      type: "warn",
    });
    return;
  }
  qrcreate.config.backgroundOptions.color = "transparent";
  qrcreate.config.background_default = false;
  qrcreate.select_template = item;
  await qrstyle.GenerateQrCode({ set_field: true });
  qrcreate.tab_active = "Edit Style";
};
</script>

<style></style>
